import PropTypes from 'prop-types';

import { getLYDateFor, getLYSpitDateFor } from '../../helpers/dateHelper';
import { calculateMetrics } from 'utils/analytics/metrics';

const figures = {
    totalRooms: PropTypes.number,
    guaranteedRooms: PropTypes.number,
    nonGuaranteedRooms: PropTypes.number,
    totalRevenue: PropTypes.number,
    guaranteedRevenue: PropTypes.number,
    nonGuaranteedRevenue: PropTypes.number,
};

export const figuresPropTypes = {
    ...figures,
    lySpit: PropTypes.shape(figures),
    change: PropTypes.shape({
        totalRooms: PropTypes.number,
        guaranteedRooms: PropTypes.number,
        nonGuaranteedRooms: PropTypes.number,
    }),
    budget: PropTypes.shape({
        accommodationRevenueBudget: PropTypes.number,
        ancillaryRevenueBudget: PropTypes.number,
        fbRevenueBudget: PropTypes.number,
        otherRevenueBudget: PropTypes.number,
        roomsBudget: PropTypes.number,
        adrBudget: PropTypes.number,
        revParBudget: PropTypes.number,
    }),
    inventory: PropTypes.shape({
        availableRoomCount: PropTypes.number,
        roomCount: PropTypes.number,
        outOfOrder: PropTypes.number,
    }),
};

/**
 * Returns the current/lastYear start & end dates for a year or month period
 * @param  {moment} date   - the starting date of the current year
 * @param  {string} period - year or month
 * @return {Object} the startDate, endDate, lyStartDate & lyEndDate
 */
export const getDateRanges = (date, period = 'year') => {
    const getEndDateFor = (startDate) => {
        const periodEndDate = period === 'year' ? startDate.clone().add(11, 'months') : startDate.clone();
        return periodEndDate.endOf('month');
    };
    const getSpitDateFor = period === 'year' ? getLYDateFor : getLYSpitDateFor;

    const startDate = date.clone().startOf('month');
    const endDate = getEndDateFor(startDate);
    const lyStartDate = getSpitDateFor(startDate);
    const lyEndDate = period === 'year' ? getEndDateFor(lyStartDate) : getSpitDateFor(endDate);

    return {
        startDate,
        endDate,
        lyStartDate,
        lyEndDate,
    };
};

/**
 * Retrieve the correct room/revenue figures to display in a <Card>
 * @param  {object} row - the row of data to show in a card
 * @return {object} an object with the Card's figures props
 */
export const getPropsFromFigures = (row) => {
    const { adr, revPar, occupancy } = calculateMetrics(
        row.inventory.availableRoomCount,
        row.guaranteedRooms,
        row.guaranteedRevenue,
    );
    return {
        rooms: row.guaranteedRooms,
        ungRooms: row.nonGuaranteedRooms,
        revenue: row.guaranteedRevenue,
        ungRevenue: row.nonGuaranteedRevenue,
        budget: row.budget && row.budget.accommodationRevenueBudget,
        forecast: row.forecast && row.forecast.revenue,
        lySpitRevenue: row.lySpit && row.lySpit.guaranteedRevenue,
        change: row.change && row.change.guaranteedRooms,
        adr,
        revPar,
        occupancy,
    };
};
